'use client'
import React from 'react'
import { useDisclosure } from '@mantine/hooks'
import { Anchor, Box, Burger } from '@mantine/core'
import styles from './BurgerMenu.module.css'
import { IoLocationOutline, IoMap, IoMapOutline } from 'react-icons/io5'
import { IoHelpCircleOutline } from 'react-icons/io5'
import { IoEarthOutline } from 'react-icons/io5'
import { IoHomeOutline } from 'react-icons/io5'
import { FaRegHandshake } from 'react-icons/fa'
import { LuStore } from 'react-icons/lu'
import { FaRegEnvelope } from 'react-icons/fa6'

import { Grid, Stack } from '@mantine/core'

const getMenuItems = (locale) => [
  { label: locale?.navbar?.home, icon: <IoHomeOutline color="black" />, href: '/' },
  {
    label: locale?.navbar?.local_internet,
    icon: <IoLocationOutline color="black" />,
    href: '/local'
  },
  {
    label: locale?.navbar?.regional_internet,
    icon: <IoMapOutline color="black" />,
    href: '/regional'
  },
  {
    label: locale?.navbar?.global_internet,
    icon: <IoEarthOutline color="black" />,
    href: '/global'
  },
  {
    label: locale?.navbar?.what_is_esim,
    icon: <IoHelpCircleOutline color="black" />,
    href: '/esim'
  },
  {
    label: locale?.navbar?.partner_program,
    icon: <FaRegHandshake color="black" />,
    href: '/partner-program-disclaimer'
  },
  {
    label: locale?.navbar?.partners_market,
    icon: <LuStore color="black" />,
    href: '/partners/login'
  },
  {
    label: locale?.navbar?.contact,
    icon: <FaRegEnvelope color="black" />,
    href: '/contact'
  }
]

export default function BurgerMenu({ lang = 'en', locale }) {
  const [opened, { toggle }] = useDisclosure()
  const menuItems = getMenuItems(locale)
  
  return (
    <>
      <div className={styles.burgerContainer}>
        <Burger
          lineSize={4}
          size="lg"
          opened={opened}
          onClick={toggle}
          color={opened ? 'redi-blue.0' : 'white'}
        />
      </div>

      {opened && (
        <div className={styles.overlay}>
          <div className={styles.menu}>
            <Stack gap={'md'}>
              {menuItems.map((item, index) => (
                <Grid key={index} align="center">
                  <Grid.Col span="auto">
                    <Anchor
                      underline="never"
                      href={`/${lang}${item.href}`}
                      className={styles.menuItem}
                    >
                      {item.label}
                    </Anchor>
                  </Grid.Col>
                  <Grid.Col span="content">
                    <Anchor
                      underline="never"
                      href={`/${lang}${item.href}`}
                      className={styles.menuItem}
                    >
                      {item.icon}
                    </Anchor>
                  </Grid.Col>
                </Grid>
              ))}
            </Stack>
          </div>
        </div>
      )}
    </>
  )
}
